import { Controller } from '@hotwired/stimulus'
import { toPng } from 'html-to-image'

export default class extends Controller {
  static targets = [
    'currentColor',
    'currentBackColor',
    'palette',
    'preview',
    'previewPixel',
    'grid',
    'gridPixel',
    'text',
    'textPreview',
    'name',
    'namePreview',
    'penButton',
    'undoButton',
    'redoButton',
    'submitButton',
    'imageData',
    'advancedButton',
    'advanced',
    'step',
    'nameNextButton',
    'textNextButton',
    'nameCount',
    'textCount',
    'resetButton',
    'resetConfirm',
    'canvas'
  ]
  static values = {
    drawing: { type: Boolean, default: false },
    backDrawing: { type: Boolean, default: false },
    color: { type: String, default: '1' },
    backColor: { type: String, default: '0' },
    pen: { type: Number, default: 1 },
    image: { type: String, default: '0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000' },
    step: { type: Number, default: 0 },
    done: { type: Boolean, default: false }
  }

  connect() {
    document.querySelector('#soul').classList.remove('hidden')
    this.colors = ['0', 'r', 't', 'o', 'b', '1', 'p', 'g', 'y']
    this.colorClasses = this.colors.map(c => `bg-soul-${c}`)
    this.colorMap = {
      '0': '#000000',
      '1': '#FFFFFF',
      'r': '#FF0000',
      't': '#42FCFF',
      'o': '#FCA600',
      'b': '#003CFF',
      'p': '#D535D9',
      'g': '#00C000',
      'y': '#FFFF00'
    }
    this.colorNames = {
      '0': 'Black',
      '1': 'White',
      'r': 'Red',
      't': 'Light Blue',
      'o': 'Orange',
      'b': 'Dark Blue',
      'p': 'Purple',
      'g': 'Green',
      'y': 'Yellow'
    }
    this.nameTarget.value = ''
    this.textTarget.value = ''

    // Load backup, if it exists and is valid
    if (localStorage.getItem('submit-name') !== null) {
      this.nameTarget.value = localStorage.getItem('submit-name')
      this.namePreviewTarget.innerHTML = this.nameTarget.value
      this.updateName()
    }
    if (localStorage.getItem('submit-image') !== null && this.checkImageData(localStorage.getItem('submit-image'))) {
      this.loadImageData(localStorage.getItem('submit-image'))
    } else {
      this.refreshImageData()
    }
    if (localStorage.getItem('submit-text') !== null) {
      this.textTarget.value = localStorage.getItem('submit-text')
      this.textPreviewTarget.innerHTML = this.textTarget.value
      this.updateText()
    }
    if (localStorage.getItem('submit-step') !== null && this.stepTargets[localStorage.getItem('submit-step')] !== undefined) {
      if (this.stepValue > 5) {
        this.stepValue = 5
        this.setStep(this.stepTargets[5])
        this.doneValue = true
      }
      this.stepValue = localStorage.getItem('submit-step')
      this.setStep(this.stepTargets[this.stepValue])
    } else {
      this.setStep(this.stepTargets[0])
    }
    if (localStorage.getItem('submit-done') !== null) {
      this.doneValue = localStorage.getItem('submit-done')
    }

    // Prep history
    this.undoHistory = []
    this.redoHistory = []
    this.resetUndoHistory()
    this.resetRedoHistory()
  }

  loadImageData(data, addToUndo=false) {
    if (this.checkImageData(data)) {
      let x = 1
      let y = 1
      for (const color of data) {
        for (const pixel of document.querySelectorAll(`[data-x="${x}"][data-y="${y}"]`)) {
          this.updatePixel(pixel, color)
        }
        y += 1
        if (y > 50) {
          x += 1
          y = 1
        }
      }
      localStorage.setItem('submit-image', this.imageValue)
      if (addToUndo) {
        this.addToUndoHistory(this.imageValue)
      }
    } else {
      console.log('Failed to load image data', data)
    }
  }

  reset() {
    let cleanSlate = ''
    for (let i = 0; i < 2500; i++) {
      cleanSlate += '0'
    }
    this.loadImageData(cleanSlate)
  }

  refreshImageData() {
    let newText = ''
    for (const pixel of document.querySelectorAll('.pixel')) {
      newText += pixel.dataset.color
    }
    this.imageValue = newText
  }

  changeColor(e) {
    if ('button' in e && e.button === 2) {
      return false
    }
    this.colorValue = e.params.color
    this.removeAllColorClasses(this.currentColorTarget)
    this.currentColorTarget.classList.add(`bg-soul-${this.colorValue}`)
    this.currentColorTarget.setAttribute('aria-label', `Current color: ${this.colorNames[this.colorValue]}`)
  }

  changeBackColor(e) {
    this.backColorValue = e.params.color
    this.removeAllColorClasses(this.currentBackColorTarget)
    this.currentBackColorTarget.classList.add(`bg-soul-${this.backColorValue}`)
    this.currentBackColorTarget.setAttribute('aria-label', `Current color: ${this.colorNames[this.backColorValue]}`)
  }

  startDrawing(e) {
    if ('button' in e && e.button === 2) {
      this.backDrawingValue = true
    } else {
      this.drawingValue = true
    }
  }

  stopDrawing(e) {
    if (this.drawingValue || this.backDrawingValue) {
      this.backDrawingValue = false
      this.drawingValue = false

      this.addToUndoHistory(this.imageValue)
      localStorage.setItem('submit-image', this.imageValue)
    }
  }

  addToUndoHistory(data) {
    this.undoHistory.push(data)

    if (this.undoHistory.length > 1) {
      this.undoButtonTarget.removeAttribute('disabled')
      this.resetRedoHistory()
    }
  }

  addToRedoHistory(data) {
    this.redoHistory.push(data)
    this.redoButtonTarget.removeAttribute('disabled')
  }

  undo() {
    if (this.undoHistory.length > 0) {
      if (this.redoHistory.length == 0) {
        const currentImage = this.undoHistory.pop()
      }
      const undoImage = this.undoHistory.pop()
      this.addToRedoHistory(this.imageValue)
      this.loadImageData(undoImage)

      if (this.undoHistory.length == 0) {
        this.resetUndoHistory()
      }
    }
  }

  redo() {
    if (this.redoHistory.length > 0) {
      const redoImage = this.redoHistory.pop()
      this.addToUndoHistory(this.imageValue)
      this.loadImageData(redoImage)
      this.addToUndoHistory(redoImage)

      if (this.redoHistory.length == 0) {
        this.resetRedoHistory()
      }
    }
  }

  resetUndoHistory() {
    this.undoHistory = []
    this.addToUndoHistory(this.imageValue)
    this.undoButtonTarget.setAttribute('disabled', true)
  }

  resetRedoHistory() {
    this.redoHistory = []
    this.redoButtonTarget.setAttribute('disabled', true)
  }

  draw(e) {
    if (this.drawingValue || this.backDrawingValue) {
      const hoveredElement = document.elementFromPoint(e.clientX, e.clientY)
      const hoveredX = parseInt(hoveredElement.dataset.x)
      const hoveredY = parseInt(hoveredElement.dataset.y)
      let color = this.colorValue
      if (this.backDrawingValue) {
        color = this.backColorValue
      }
      for (const pixel of document.querySelectorAll(`[data-x="${hoveredX}"][data-y="${hoveredY}"]`)) {
        this.updatePixel(pixel, color)
      }
      if (this.penValue > 1) {
        const startX = hoveredX - (this.penValue - 1)
        const endX = hoveredX + (this.penValue - 1)
        const startY = hoveredY - (this.penValue - 1)
        const endY = hoveredY + (this.penValue - 1)
        let x = startX
        let y = startY
        for (x; x <= endX; x++) {
          for (y; y <= endY; y++) {
            for (const pixel of document.querySelectorAll(`[data-x="${x}"][data-y="${y}"]`)) {
              this.updatePixel(pixel, color)
            }
          }
          y = startY
        }
      }
    }
  }

  updatePixel(pixel, color) {
    if (pixel.dataset.color != color) {
      pixel.setAttribute('data-color', color)
      this.removeAllColorClasses(pixel)
      pixel.classList.add(`bg-soul-${color}`)
      pixel.setAttribute('aria-label', `Pixel ${pixel.dataset.x}x${pixel.dataset.y}: ${this.colorNames[color]}`)
      this.replaceImagePixel(pixel.dataset.x, pixel.dataset.y, color)
    }
  }

  updateText() {
    const sanitized = this.sanitizeFieldCharacters(this.textTarget)
    if (sanitized) {
      document.getElementById('text_warning').classList.remove('hidden')
    }
    this.sanitizeFieldLength(this.textTarget, 180)
    this.textPreviewTarget.innerHTML = this.textTarget.value
    localStorage.setItem('submit-text', this.textTarget.value)
    if (this.textTarget.value.length > 0 && this.textTarget.value.length <= 180) {
      this.textNextButtonTarget.removeAttribute('disabled')
    } else {
      this.textNextButtonTarget.setAttribute('disabled', true)
    }
    this.textCountTarget.innerHTML = 180 - this.textTarget.value.length
    this.textCountTarget.setAttribute('aria-label', `${180 - this.textTarget.value.length} characters remaining`)
    this.textCountTarget.style.opacity = (this.textTarget.value.length / 180)
    if (this.textTarget.value.length >= 180) {
      this.textCountTarget.classList.add('!text-undertale-red')
    } else {
      this.textCountTarget.classList.remove('!text-undertale-red')
    }
  }

  updateName() {
    const sanitized = this.sanitizeFieldCharacters(this.nameTarget)
    if (sanitized) {
      document.getElementById('name_warning').classList.remove('hidden')
    }
    this.sanitizeFieldLength(this.nameTarget, 28)
    this.namePreviewTarget.innerHTML = this.nameTarget.value
    localStorage.setItem('submit-name', this.nameTarget.value)
    if (this.nameTarget.value.length > 0 && this.nameTarget.value.length <= 28) {
      this.nameNextButtonTarget.removeAttribute('disabled')
    } else {
      this.nameNextButtonTarget.setAttribute('disabled', true)
    }
    this.nameCountTarget.innerHTML = 28 - this.nameTarget.value.length
    this.nameCountTarget.setAttribute('aria-label', `${28 - this.nameTarget.value.length} characters remaining`)
    this.nameCountTarget.style.opacity = (this.nameTarget.value.length / 28)
    if (this.nameTarget.value.length >= 28) {
      this.nameCountTarget.classList.add('!text-undertale-red')
    } else {
      this.nameCountTarget.classList.remove('!text-undertale-red')
    }
  }

  sanitizeFieldCharacters(field) {
    const originalFieldValue = field.value
    field.value = field.value.replace(/[^\u0020-\u007E\u0080-\u00A3\u00A5-\u00AC\u00AE-\u00B1\u00B4-\u00B8\u00BB\u00BE-\u00FF\u010C-\u010F\u011A-\u011B\u0131\u0152-\u0153\u0160-\u0161\u017D-\u017E\u0192\u02C7\u02D8-\u02DD\u20A3-\u20A7\u20AC\u2113\u2122\u2190-\u2193\u2212-\u2219\u221E\u2260\u2264-\u2265\u25A0\u25A1\u25B2-\u25B3\u25BC-\u25BD\u25C6-\u25C7\u25CB\u25CF\u25E6\u266A\u266B\uFB01-\uFB02]/g, '')
    return originalFieldValue != field.value
  }

  sanitizeFieldLength(field, maxLength) {
    if (field.value.length > maxLength) {
      field.value = field.value.substring(0, maxLength)
    }
  }

  removeAllColorClasses(element) {
    for (const colorClass of this.colorClasses) {
      element.classList.remove(colorClass)
    }
  }

  replaceImagePixel(x, y, character) {
    const index = ((parseInt(x) - 1) * 50) + parseInt(y) - 1
    this.imageValue = this.imageValue.substring(0, index) + character + this.imageValue.substring(index + 1)
  }

  imageValueChanged() {
    this.imageDataTarget.value = this.imageValue.toString()
    for (const canvas of this.canvasTargets) {
      this.updateCanvas(canvas, this.imageValue)
    }
  }

  checkImageData(data) {
    return /^[0rtob1pgy]{2500}$/.test(data)
  }

  copyImageDataToClipboard() {
    navigator.clipboard.writeText(this.imageValue)
  }

  loadImageDataFromString() {
    this.loadImageData(this.imageDataTarget.value.toString())
  }

  setPen(e) {
    this.penValue = e.params.size
    for (const button of this.penButtonTargets) {
      button.classList.remove('active')
      if (this.penValue == button.dataset.submitSizeParam) {
        button.classList.add('active')
      }
    }
  }

  imageToPng(e) {
    if (this.checkImageData(this.imageValue)) {
      const button = e.target
      button.setAttribute('disabled', true)
      button.innerHTML = '<span class="inline-block animate-spin">◡</span>'
      toPng(document.querySelector(e.params.element), { pixelRatio: 2 })
      .then((dataUrl) => {
        const link = document.createElement('a')
        link.classList.add('hidden')
        link.href = dataUrl
        link.download = 'you.png'
        if (this.nameTarget.value.length > 0) {
          link.download = `${this.nameTarget.value}_${e.params.filename}.png`
        }
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
      setTimeout(function() {
        button.removeAttribute('disabled')
        button.innerHTML = e.params.filename
      }, 3000)
    } else {
      console.log('Malformed image, cannnot save')
    }
  }

  submitForm(e) {
    if (this.nameTarget.value.length > 0 && this.nameTarget.value.length <= 28 && this.imageValue.length == 2500 && this.textTarget.value.length > 0 && this.textTarget.value.length <= 180) {
      this.submitButtonTarget.setAttribute('disabled', true)
      this.submitButtonTarget.innerHTML = 'Submitting..'
      const formData = new FormData()
      formData.append('name', this.nameTarget.value)
      formData.append('image', this.imageValue)
      formData.append('text', this.textTarget.value)
      fetch('https://127.0.0.1', {
        method: 'POST',
        body: formData
      })
      .then(async response => {
        if (response.ok) {
          this.doneValue = true
          localStorage.setItem('submit-done', true)
          this.submitButtonTarget.innerHTML = 'SUBMIT'
        } else {
          this.submitButtonTarget.innerHTML = 'ERROR'
          console.log('something bad happened', response)
        }
        this.submitButtonTarget.removeAttribute('disabled')
      })
    }
  }

  showAdvanced() {
    this.advancedTarget.classList.remove('hidden')
    this.advancedButtonTarget.classList.add('hidden')
  }

  nextStep() {
    this.hideFieldWarnings()
    if (this.stepTargets.length > (this.stepValue + 1)) {
      const currentStep = this.stepTargets[this.stepValue]
      this.stepValue += 1
      const newStep = this.stepTargets[this.stepValue]

      this.animateToStep(currentStep, newStep)
    } else {
      console.log('already at final step')
    }
  }

  prevStep() {
    this.hideFieldWarnings()
    if ((this.stepValue - 1) >= 0) {
      const currentStep = this.stepTargets[this.stepValue]
      this.stepValue -= 1
      const newStep = this.stepTargets[this.stepValue]

      this.animateToStep(currentStep, newStep)
    } else {
      console.log('already at first step')
    }
  }

  setStep(newStep) {
    this.hideFieldWarnings()
    for (const step of this.stepTargets) {
      step.classList.add('hidden', 'opacity-0')
      if (step == newStep) {
        newStep.classList.remove('motion-safe:animate-form-out', 'opacity-0', 'hidden')
      }
    }
  }

  hideFieldWarnings() {
    for (const fieldWarning of document.querySelectorAll('.field-warning')) {
      fieldWarning.classList.add('hidden')
    }
  }

  animateToStep(fromStep, toStep) {
    fromStep.classList.add('motion-safe:animate-form-out', 'opacity-0')
    setTimeout(function() {
      fromStep.classList.add('hidden')
      fromStep.classList.remove('motion-safe:animate-form-out', 'opacity-0')
    }, 250)

    toStep.classList.add('motion-safe:animate-form-in')
    toStep.classList.remove('hidden', 'opacity-0')
    toStep.children[0].focus()

    document.querySelector('#soul').scrollTo({ top: 0 })

    localStorage.setItem('submit-step', this.stepValue)
  }

  loadImage(e) {
    this.loadImageData(e.params.image, true)
  }

  nextIfNameGood() {
    if (this.nameTarget.value.length > 0 && this.nameTarget.value.length <= 28) {
      this.nextStep()
    }
  }

  nextIfTextGood() {
    if (this.textTarget.value.length > 0 && this.textTarget.value.length <= 180) {
      this.nextStep()
    }
  }

  doneValueChanged() {
    if (this.doneValue) {
      for (const element of document.querySelectorAll('.hide-when-done')) {
        element.classList.add('hidden')
      }
      for (const element of document.querySelectorAll('.show-when-done')) {
        element.classList.remove('hidden')
      }
    } else {
      for (const element of document.querySelectorAll('.hide-when-done')) {
        element.classList.remove('hidden')
      }
      for (const element of document.querySelectorAll('.show-when-done')) {
        element.classList.add('hidden')
      }
    }
  }

  updateCanvas(canvas, image) {
    const ctx = canvas.getContext('2d')    
    const gridSize = 50
    const pixelSize = canvas.width / gridSize
    const colorMap = {
      '0': '#000000',
      '1': '#FFFFFF',
      'r': '#FF0000',
      't': '#42FCFF',
      'o': '#FCA600',
      'b': '#003CFF',
      'p': '#D535D9',
      'g': '#00C000',
      'y': '#FFFF00'
    }

    ctx.clearRect(0, 0, canvas.width, canvas.height)

    for (let y = 0; y < gridSize; y++) {
      for (let x = 0; x < gridSize; x++) {
        const index = y * gridSize + x
        const char = image[index]

        const color = colorMap[char] || '#000000'
        ctx.fillStyle = color
        ctx.fillRect(x * pixelSize, y * pixelSize, pixelSize, pixelSize)
      }
    }
  }

  youSure() {
    this.resetButtonTarget.classList.add('hidden')
    this.resetConfirmTarget.classList.remove('hidden')
  }

  resetAll() {
    this.nameTarget.value = ''
    this.updateName()
    this.textTarget.value = ''
    this.updateText()
    this.reset()
    this.doneValue = false
    this.setStep(this.stepTargets[0])
    this.stepValue = 0
    localStorage.clear()
  }
}
